import React from 'react';

function Logo() {
    return (
        <a className='logo link-hover' href='/'>Akif Mohammed</a>
    );
}

export default Logo;